import Request from '../../lib/exchange/request'
import RequestTypes from '../../lib/exchange-api/request-types'

class CmdUpdateSoftwareRequest extends Request {
    constructor(mode) {
        super({
            req: RequestTypes.CMD_UPDATE_SOFTWARE,
            req_id: 0,
            mode: mode
        });
    }
}

export default CmdUpdateSoftwareRequest;